import React from 'react'
import Container from "src/components/Container/Container"
import './Footer.scss'
import SnowLines from "src/components/SnowLines/SnowLines"
import ArrrAgency from "src/components/ArrrAgency/ArrrAgency"
import { getStyles } from "src/helpers"

interface IFooter extends React.HTMLAttributes<HTMLDivElement> {
}

const Footer: React.FC<IFooter> = (props) => {
    const { className } = props

    const styles = getStyles("footer__outer-container", [], className)

    return (
        <Container
            containerOuterClassName={styles}
        >
            <footer className={"footer"}>
                <ArrrAgency/>
            </footer>
            <SnowLines />
        </Container>
    )
}

export default Footer